import { lightGrey17 } from '@edulastic/colors'
import React from 'react'
import styled from 'styled-components'

const TimeDisplay = ({ minutes, seconds, ariaLabel, showLabels = true }) => {
  const format = (num) => String(num).padStart(2, '0')

  // Create a human-readable time description for screen readers
  const timeDescription = `${minutes} minute${
    minutes !== 1 ? 's' : ''
  } and ${seconds} second${seconds !== 1 ? 's' : ''}`

  return (
    <Timer
      role="timer"
      aria-label={ariaLabel || `Time remaining: ${timeDescription}`}
      tabIndex="0"
    >
      <TimeBox>
        <TimeValue aria-label={`${minutes} minutes`}>
          {format(minutes)}
        </TimeValue>
        {showLabels && <TimeLabel aria-hidden="true">min</TimeLabel>}
      </TimeBox>
      <Colon aria-hidden="true">:</Colon>
      <TimeBox>
        <TimeValue aria-label={`${seconds} seconds`}>
          {format(seconds)}
        </TimeValue>
        {showLabels && <TimeLabel aria-hidden="true">sec</TimeLabel>}
      </TimeBox>
    </Timer>
  )
}

export default TimeDisplay

const Timer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: sans-serif;
  gap: 8px;
`

const TimeBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const TimeValue = styled.span`
  font-size: 14px;
  font-weight: bold;
  padding: 8px 12px;
  background: #f2f2f2;
  border-radius: 6px;
`

const Colon = styled.span`
  font-size: 14px;
  font-weight: bold;
  margin-top: -14px;
`

const TimeLabel = styled.span`
  font-size: 11px;
  color: ${lightGrey17};
`
